import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useRouter } from 'next/router';
import { useState } from 'react';
import imgLocale1 from './imgs/imgLocale1';
import imgLocale2 from './imgs/imgLocale2';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const img1 = imgLocale1[locale] || imgLocale1['us'];
    const img2 = imgLocale2[locale] || imgLocale2['us'];
    const listTabH: EfTabItemProps[] = [
        {
            type: 'a1',
            title: t('J_item1_tab'),
        },
        {
            type: 'a2',
            title: t('J_item2_tab'),
        },
    ];

    const tabObj: any = {
        a1: {
            title: t('J_item1_title'),
            desc: t('J_item1_desc'),
            pc: img1.pc,
            pad: img1.pc,
            h5: img1.h5,
        },
        a2: {
            title: t('J_item2_title'),
            desc: t('J_item2_desc'),
            pc: img2.pc,
            h5: img2.h5,
        },
    };
    if (IS_NA_SITES) {
        tabObj.a3 = {
            title: t('J_item3_title'),
            desc: t('J_item3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1721031870774/a3.jpg',
        };
    }
    // 选中的tab
    const [activeType, setActiveType] = useState('a1');
    const [activeItem, setActiveItem] = useState(tabObj[activeType]);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type);
        setActiveItem(tabObj[item.type] || tabObj['a1']);
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection label={t('J_label')} title={t('J_title')} desc={t('J_desc')} theme={IS_EU_SITES ? 'white' : 'black'} />
            <ul className={`boxes ${IS_EU_SITES ? 'eu' : ''}`}>
                {listTabH?.map((item: any, k: number) => (
                    <li className={`box${IS_EU_SITES ? ' eu' : ''}${`a${k + 1}` === activeType ? ' active' : ''}`} key={k}>
                        <div className="box-img">
                            <EfImg pc={tabObj[`a${k + 1}`].pc} pad={tabObj[`a${k + 1}`]?.pad} h5={tabObj[`a${k + 1}`].h5} />
                        </div>
                        <div className="box-msg">
                            <div className="box-title">{tabObj[`a${k + 1}`].title}</div>
                            <div className="box-desc">{tabObj[`a${k + 1}`].desc}</div>
                        </div>
                    </li>
                ))}
            </ul>
            <EfTab list_name={t('J_title')} items={listTabH} activeType={activeType} onChange={activeTypeCallback} theme={IS_EU_SITES ? 'black' : 'white'} />
        </div>
    );
}
